<template>
  <picker
    @select="addEmoji"
    title="Pick your emoji"
    emoji="point_up"
    :native="true"
    v-show="showEmojiWindow"
  >
  </picker>
</template>

<script>
import { Picker } from "emoji-mart-vue";
export default {
  name: "EmojiWindow",
  components: {
    Picker
  },
  props: {
    showEmojiWindow: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    addEmoji(emoji) {
      this.$emit("add-emoji", emoji);
    },
    handleClose() {
      this.$emit("close-window");
    },
    hideMenu(e) {
      if (!this.$el.contains(e.target)) {
        this.handleClose();
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.hideMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideMenu);
  }
};
</script>

<style scoped></style>
